import React from "react";
import { Outlet } from "react-router-dom";
import HeaderIcon from './media/cubic_w.png'
import { useUser } from "./context/user.context";

const Application = () => {

    return ( 
        <div className="App">
            {/* <img className="footer-icon" src={Icon} alt="Cubic"/> */}
            <img className="header-icon" src={HeaderIcon} alt="Cubic"/>
            <div className="header"><h4>Cubic VIU</h4></div>
            <div className="footer">Cubic | Vehicle Interface Unit | Version 1.0.0
                <div className="footer-user-details"></div>
            </div>
            <Outlet />
        </div>
    )
}


export default Application;